import React from 'react';

import {FormattedMessage, injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';
import './MobileLegendsRankPicker.sass';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class MobileLegendsRankPicker1to250 extends React.PureComponent {
  static describeRank = rank => rank.toString();

  static minValue = 1;
  static maxValue = 250;

  static getDefaultValue = () => [1, 50];

  static marks = {
    1: (
      <span>
          1
      </span>
       ),
    25: (
      <span>
        25
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--blue"><FormattedMessage id="section.calc-texts.honor"/></span>
      </span>
        ),
    50: (
      <span>
        50
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--purple"><FormattedMessage id="section.calc-texts.glory"/></span>
      </span>
        ),
    100: (
      <span>
        100
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--red"><FormattedMessage id="section.calc-texts.immortal"/></span>
      </span>
        ),
    150: (
      <span>
        150
      </span>
         ),
    200: (
      <span>
        200
      </span>
        ),
    250: (
      <span>
        250
      </span>
        ),
    };

    render() {
      const {intl, collapsed, value, onChange} = this.props;

        return (
          <div>
            <div className="range-inputs">
              <div className="range-inputs__item">
                <RestrictedNumberInput
                  label={intl.formatMessage({id: 'section.product.level'})}
                  min={MobileLegendsRankPicker1to250.minValue}
                  max={MobileLegendsRankPicker1to250.maxValue}
                  value={value[0]}
                  onChange={newValue => onChange([
                      newValue,
                      value[1]
                  ])}
                />
              </div>

                <div className="range-inputs__divider"/>
                  <div className="range-inputs__item">
                    <RestrictedNumberInput
                      label={intl.formatMessage({id: 'section.product.wanted'})}
                      min={MobileLegendsRankPicker1to250.minValue}
                      max={MobileLegendsRankPicker1to250.maxValue}
                      value={value[1]}
                      onChange={newValue => onChange([
                        value[0],
                        newValue
                      ])}
                    />
                    </div>
                </div>

                {!collapsed && (
                  <div className="slider">
                    <VariableStepRange
                      className="slider-mobile-legends-1-200"
                      step={1}
                      min={MobileLegendsRankPicker1to250.minValue}
                      max={MobileLegendsRankPicker1to250.maxValue}
                      marks={MobileLegendsRankPicker1to250.marks}
                      value={value}
                      onChange={onChange}
                    />
                  </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/mobileLegends/MobileLegendsRankPicker1to250.js